import { render, staticRenderFns } from "./GoodsBuyForm.vue?vue&type=template&id=26220dc5&scoped=true"
import script from "./GoodsBuyForm.vue?vue&type=script&lang=js"
export * from "./GoodsBuyForm.vue?vue&type=script&lang=js"
import style0 from "./GoodsBuyForm.vue?vue&type=style&index=0&id=26220dc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26220dc5",
  null
  
)

export default component.exports